import { Plus, Trash2 } from "lucide-react";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { CATEGORIES } from "@/data/products";

export const OTHER = "other";
export const findProduct = (id) => {
  for (const c of CATEGORIES) {
    const p = c.products.find((x) => x.id === id);
    if (p) return { p, c };
  }
  return null;
};

const ProductSelect = ({ value, onChange, i }) => (
  <Select value={value || undefined} onValueChange={onChange}>
    <SelectTrigger className="h-11 bg-white" data-testid={`line-${i}-product-select`}><SelectValue placeholder="Choose a product" /></SelectTrigger>
    <SelectContent className="max-h-80">
      {CATEGORIES.map((c) => (
        <SelectGroup key={c.slug}>
          <SelectLabel className="text-[11px] uppercase tracking-wider text-slate-400">{c.name}</SelectLabel>
          {c.products.map((p) => <SelectItem key={p.id} value={p.id} data-testid={`line-${i}-option-${p.id}`}>{p.name}</SelectItem>)}
        </SelectGroup>
      ))}
      <SelectItem value={OTHER} data-testid={`line-${i}-option-other`}>Other / not listed</SelectItem>
    </SelectContent>
  </Select>
);

const Line = ({ line, i, update, remove, canRemove }) => {
  const found = findProduct(line.id);
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-3" data-testid={`quote-line-${i}`}>
      <div className="flex items-center gap-3">
        {found && <img src={found.p.image} alt="" className="hidden h-11 w-11 shrink-0 rounded object-contain mix-blend-multiply sm:block" />}
        <div className="min-w-0 flex-1"><ProductSelect value={line.id} onChange={(v) => update({ id: v })} i={i} /></div>
        <Input type="number" min="1" inputMode="numeric" value={line.qty} onChange={(e) => update({ qty: e.target.value })} placeholder="Qty" aria-label="Quantity" className="h-11 w-20 shrink-0 bg-white sm:w-24" data-testid={`line-${i}-qty-input`} />
        {canRemove && <button type="button" onClick={remove} aria-label="Remove product" className="shrink-0 p-1 text-slate-400 hover:text-[#C20500]" data-testid={`line-${i}-remove`}><Trash2 className="h-4 w-4" /></button>}
      </div>
      {line.id === OTHER && <Input value={line.text} onChange={(e) => update({ text: e.target.value })} placeholder="Describe the product, e.g. 9 kg foam extinguisher" className="mt-3 h-11 bg-white" data-testid={`line-${i}-other-input`} />}
    </div>
  );
};

export const ProductLines = ({ lines, setLines }) => (
  <div className="space-y-2" data-testid="quote-product-lines">
    {lines.map((l, i) => (
      <Line key={i} line={l} i={i} canRemove={lines.length > 1}
        update={(patch) => setLines((p) => p.map((x, j) => (j === i ? { ...x, ...patch } : x)))}
        remove={() => setLines((p) => p.filter((_, j) => j !== i))} />
    ))}
    <button type="button" onClick={() => setLines((p) => [...p, { id: "", qty: "", text: "" }])} className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#C20500] hover:underline" data-testid="quote-add-line-button">
      <Plus className="h-4 w-4" /> Add another product
    </button>
  </div>
);

export const linesToItems = (lines) =>
  lines.filter((l) => l.id && (l.id !== OTHER || l.text.trim())).map((l) => {
    const found = findProduct(l.id);
    return { category: found ? found.c.name : "Other", description: found ? found.p.name : l.text.trim(), quantity: l.qty, specification: "" };
  });
